import { useEffect, useState } from "react";
import capitalizeFieldHeader from "../../utilis/capitalizeFieldHeader";
import BTableRendrer from "../renderers/BTableRenderer";
import BTableDropdown from "./BTableDropdown";
import BTableHeader from "./BTableHeader";
import { Link } from "react-router-dom";
import translateFieldHeader from "../../utilis/translateFieldHeader";

function BTable({
  data,
  url,
  header,
  addOrdering,
  title,
  ordering,
  availableWidth,
  isCustomerPage,
  maxNmbOfChars,
  aboveTableComponent,
  fieldsVisibleAtBeginning = [],
  isReadOnly = false,
}) {
  const [fields, setFields] = useState([]);
  const [visibleFields, setVisibleFields] = useState([]);

  useEffect(() => {
    if (data == null || data.length === 0) {
      setFields([]);
      return;
    }
    
    let tempFields = [];
    let tempVisibleFields = [];

    for (const [key, value] of Object.entries(data[0])) {
      const fieldPair = { accessor: key, Header: translateFieldHeader(capitalizeFieldHeader(key)) };
      tempFields.push(fieldPair);

      if (fieldsVisibleAtBeginning.includes(key)) {
        tempVisibleFields.push(fieldPair);
      }
    }
    
    setFields(tempFields);
    setVisibleFields(tempVisibleFields);

    if(tempVisibleFields.length == 0) {
      setVisibleFields(tempFields);  
    }
  }, [data]);

  const onToggleField = (field) => {
    let tempFields = visibleFields;
    tempFields = tempFields.filter((val) => val !== field);
    if (tempFields.length === visibleFields.length) {
      tempFields.push(field);
    }
    setVisibleFields(tempFields);
  };

  const resetVisibleFields = () => {
    setVisibleFields(fields);
  };

  const getSingularLowercaseHeader = () => {
    return header.toLowerCase();
  };

  const computeColumnSpace = () => {
    let visibleFields = fieldsVisibleAtBeginning.length == 0 ? fields : fieldsVisibleAtBeginning;
    return visibleFields.length !== 0 ? ((availableWidth) / visibleFields.length) : 0;
  };

  const colSpace = computeColumnSpace();

  return (
    <>
      <BTableHeader header={header} />
      <div className="bg-white rounded shadow-md w-full flex flex-col border-gray-400 py-2 px-3 mt-6">
        <div className="flex justify-end">
          {aboveTableComponent}
          {!isCustomerPage && !isReadOnly && (
            <Link
              className="text-gray-800 font-bold border-gray-800 border py-1 px-2 rounded shadow-md hover:bg-gray-100 mr-2 cursor-pointer"
              to={`${title.toLowerCase()}/add`}
            >
              Addieren {getSingularLowercaseHeader()}
            </Link>
          )}
          <BTableDropdown
            fields={fields}
            onToggleField={onToggleField}
            visibleFields={visibleFields}
          />
        </div>
        <BTableRendrer
          columns={visibleFields}
          data={data}
          addOrdering={addOrdering}
          title={title}
          ordering={ordering}
          maxNmbOfChars={maxNmbOfChars}
          spacePerColumn={colSpace}
          isReadOnly={isReadOnly}
        />
      </div>
    </>
  );
}

export default BTable;
